import createReducer from '../createReducer';

const initialState = {
    crowds:null,
    getCrowdsXHR:null,
    searchResults:[],
    searchCrowdsXHR:null
};

const reducer = createReducer('crowds',initialState);

export default reducer;